// Globals
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

// Models
import { ICleanupDataItem } from '@/models/akeneoSync.model';

// Components
import { Table } from '@/ui';

// Helpers
import { getCleanupDatabaseTableColumns } from '../../helpers';

type TCleanupDatabaseTableProps = {
  data: ICleanupDataItem[] | null;
  isLoading: boolean;
};

const CleanupDatabaseTable: FC<TCleanupDatabaseTableProps> = ({ data, isLoading }) => {
  const { t } = useTranslation(['common']);

  const columns = useMemo(() => getCleanupDatabaseTableColumns(t), [t]);

  return (
    <Table
      columns={columns}
      rowKey="id"
      dataSource={data ?? []}
      loading={isLoading}
      pagination={false}
      virtual
      rowHoverable
    />
  );
};

export default CleanupDatabaseTable;
